import { z } from 'zod';

/* The kinds of correction a person can raise. A LEAF module (zod only) so the
   filter registry can name the set without reaching into attendance.schema.ts,
   which imports the registry back through flaggedScanQuery.schema.ts. */
export const CorrectionTypeSchema = z.enum([
  'MISSED_PUNCH_IN',
  'MISSED_PUNCH_OUT',
  'WRONG_TIME',
  'ADD_BREAK',
  // Field-only (raised from a device against one pinned punch). The web submit
  // path refuses it — see CorrectionRequestInputSchema.
  'VOID_PUNCH',
  'WRONG_DIRECTION', // one pinned punch, the other way round — correctionWrongDirection.ts
]);
export type CorrectionType = z.infer<typeof CorrectionTypeSchema>;
